import { ArrowLeft, ArrowRight } from "@bale/ui";
import React, { useEffect, useState } from "react";
import { digitsToHindi } from "@bale/utils";

import {
  getJalaliDateObject,
  getMonthDays,
  isBeforeToday,
  jalaliToEpoch,
  persianMonths,
} from "utils/time";
import styles from "./MonthPagination.module.scss";

interface propTypes {
  onChange: (monthBeginEpoch: number, monthEndEpoch: number) => void;
  allowedNext: number;
  openOnNextMonth?: boolean;
}

function MonthPagination(props: propTypes) {
  const todaysJalaliDate = getJalaliDateObject();
  const [currentDate, setCurrentDate] = useState(todaysJalaliDate);

  useEffect(() => {
    setCurrentDate((prev) => {
      return {
        ...prev,
        month: props.openOnNextMonth
          ? todaysJalaliDate.month + 1
          : todaysJalaliDate.month,
      };
    });
  }, [props.openOnNextMonth]);

  function clickPrevHandler() {
    const newMonth = currentDate.month - 1 === 0 ? 12 : currentDate.month - 1;
    const newYear =
      currentDate.month - 1 === 0 ? currentDate.year - 1 : currentDate.year;
    setCurrentDate((prev) => {
      return {
        ...prev,
        month: newMonth,
        year: newYear,
      };
    });

    props.onChange(
      jalaliToEpoch({ month: newMonth, year: newYear, day: 1 }),
      jalaliToEpoch({
        month: newMonth,
        year: newYear,
        day: getMonthDays(newYear, newMonth),
      })
    );
  }
  function clickNextHandler() {
    const newMonth = currentDate.month + 1 === 13 ? 1 : currentDate.month + 1;
    const newYear =
      currentDate.month + 1 === 13 ? currentDate.year + 1 : currentDate.year;
    setCurrentDate((prev) => {
      return {
        ...prev,
        month: newMonth,
        year: newYear,
      };
    });

    props.onChange(
      jalaliToEpoch({ month: newMonth, year: newYear, day: 1 }),
      jalaliToEpoch({
        month: newMonth,
        year: newYear,
        day: getMonthDays(newYear, newMonth),
      })
    );
  }

  const flexFallback = (
    <div style={{ opacity: "0" }} className={styles.PaginationItem}></div>
  );

  return (
    <div className={styles.PaginatorWrapper}>
      {/* :D */}
      {!isBeforeToday({
        ...currentDate,
        month: currentDate.month,
        day: currentDate.day - 1,
      }) ? (
        <div className={styles.PaginationItem} onClick={clickPrevHandler}>
          <ArrowRight size={16} />
          <div>
            {
              persianMonths[
                currentDate.month - 1 === 0 ? 11 : currentDate.month - 2
              ]
            }{" "}
            {digitsToHindi(
              String(
                currentDate.month - 1 > 0
                  ? currentDate.year
                  : currentDate.year - 1
              )
            )}
          </div>
        </div>
      ) : (
        flexFallback
      )}
      <div className={styles.CurrentMonth}>
        {persianMonths[currentDate.month - 1]}{" "}
        {digitsToHindi(String(currentDate.year))}
      </div>
      {(todaysJalaliDate.month + props.allowedNext) % 12 !==
      currentDate.month ? (
        <div className={styles.PaginationItem} onClick={clickNextHandler}>
          <div>
            {
              persianMonths[
                currentDate.month + 1 === 13 ? 0 : currentDate.month
              ]
            }{" "}
            {digitsToHindi(
              String(
                currentDate.month + 1 > 12
                  ? currentDate.year + 1
                  : currentDate.year
              )
            )}
          </div>
          <ArrowLeft size={16} />
        </div>
      ) : (
        flexFallback
      )}
    </div>
  );
}

export default MonthPagination;
